import { render, staticRenderFns } from "./HeaderIconsDropdown.vue?vue&type=template&id=3e06a88f&scoped=true&"
import script from "./HeaderIconsDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderIconsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06a88f",
  null
  
)

export default component.exports